module.exports = __webpack_public_path__ + "static/media/332.885b71b2.svg";